import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import CustomInput from "../../../components/CustomInput";
import { COUNTRY_KEYS } from "../../../helpers/country_keys";
import CustomDropdown from "../../../components/CustomDropdown";
import CustomButton from "../../../components/CustomButton";
import createRegistrationPromoCode from "../../../lib/registration_promos/createRegistrationPromoCode";
import { Timestamp } from "firebase/firestore";
import notify from "../../../utils/notify";
import { useNavigate } from 'react-router-dom';

export default function AddRegistrationPromoForm() {
  const navigate = useNavigate();
  const [codeValue, setCodeValue] = useState("");
  const [codeOwner, setCodeOwner] = useState("");
  const [countryCode, setCountryCode] = useState("+966");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await createRegistrationPromoCode({
        code: codeValue,
        isActive: true,
        owner: codeOwner,
        phone: `${countryCode}${phoneNumber}`,
        createdAt: Timestamp.now(),
      });
      console.log("done!");
      navigate(0);
    } catch (error) {
      setIsLoading(false);
      notify("ERROR", "حصل خطأ.");
    }
    setIsLoading(false);
  };
  return (
    <form onSubmit={(e) => handleSubmit(e)}>
      <ToastContainer />
      <div className="w-96">
        <div>
          <label className="text-text-2-color font-bold">الكود</label>
          <CustomInput
            type="text"
            value={codeValue}
            setValue={setCodeValue}
            placeholder="ينصح بكتابة كود قصير ومعبر عن المالك مثال: MUATH3904"
            customStyle="mt-5 mb-5"
            isRequired={true}
          />
        </div>
        <div>
          <label className="text-text-2-color font-bold">اسم مالك الكود</label>
          <CustomInput
            type="text"
            value={codeOwner}
            setValue={setCodeOwner}
            placeholder="ادخل الاسم الكامل لمالك الكود..."
            customStyle="mt-5 mb-5"
            isRequired={true}
          />
        </div>
        <div>
          <label className="text-text-2-color font-bold">رقم الجوال</label>
          <div className="flex gap-5 ">
            <CustomInput
              type="number"
              value={phoneNumber}
              setValue={setPhoneNumber}
              placeholder="5XXXXXXXX"
              customStyle="mt-5 mb-5 w-full"
              isRequired={true}
            />
            <CustomDropdown
              options={COUNTRY_KEYS}
              customStyle="mt-5 mb-5"
              style={{ maxWidth: 100 }}
              defaultValue={countryCode}
              setValue={setCountryCode}
              listName="countryCodes"
              isRequired={true}
            />
          </div>
        </div>
      </div>
      <CustomButton
        title="إنشاء"
        customStyle="p-5 mt-10"
        isLoading={isLoading}
      />
    </form>
  );
}
